import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import style from "./Input.module.css";
import "react-quill/dist/quill.snow.css";

const FormInputRTE = ({
  name,
  label,
  control,
  rules,
  error,
  placeholder = "Enter the workshop description here...",
}) => {
  return (
    <Box className={style.control}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <ReactQuill
            className={style.quill}
            theme="snow"
            value={field.value}
            placeholder={placeholder}
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        )}
      />
    </Box>
  );
};

export default FormInputRTE;
